<template>
  <badge-icon v-if="showChangeIcon(keyList)" class="-sm -changed _ml-10">変更あり</badge-icon>
</template>

<script>
import changeIcon from '../../components/mixin/ChangeIcon'
import BadgeIcon from './BadgeIcon'
export default {
  name: 'change-badge-icon',
  components: {BadgeIcon},
  props: ['keyList', 'diffKeys'],
  mixin: [changeIcon],
  methods: {
    showChangeIcon (keyList) {
      if (keyList && keyList.length > 0) {
        for (let key of keyList) {
          if (this.diffKeys.indexOf(key) > -1) {
            return true
          }
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/badges/ChangeBadgeIcon.vue